import react from "react";
import "./Spinner.css";

export default function Spinner(props) {
  return <div id="loader"></div>;
}
